import { criarCatalogoColunas } from '@/utils/catalogoColunas';

/**
 * Catálogos de colunas das duas abas da tela de cobranças.
 *
 * `sortable` só é true onde o backend sabe ordenar — as whitelists
 * `CobrancaConsultaFilter::ORDENACAO_PERMITIDA` e `TaxaMercadoPagoFilter::ORDENACAO_PERMITIDA`.
 * Marcar como ordenável uma coluna fora da whitelist não quebra a tela (o backend ignora e usa a
 * ordem padrão), mas mente para o usuário: o clique não faria nada.
 */

export const COLUNAS_COBRANCAS = [
    { value: 'id', text: 'ID', padrao: true, sortable: true },
    { value: 'external_id', text: 'Charge EFI', padrao: true, sortable: true },
    { value: 'empresa', text: 'Empresa', padrao: true, sortable: true, fixa: true },
    { value: 'empresa_ativa', text: 'Emp. ativa', padrao: true, sortable: true },
    { value: 'plano', text: 'Plano', padrao: false, sortable: true },
    { value: 'assinatura_id', text: 'Assinatura', padrao: false, sortable: true },
    { value: 'status_assinatura', text: 'Status assin.', padrao: false, sortable: true },
    { value: 'periodicidade', text: 'Periodicidade', padrao: false, sortable: true },
    { value: 'total', text: 'Total', padrao: true, sortable: true },
    { value: 'total_pago', text: 'Total pago', padrao: true, sortable: true },
    { value: 'diferenca', text: 'Diferença', padrao: false, sortable: true },
    { value: 'status', text: 'Status', padrao: true, sortable: true },
    { value: 'forma_pagamento', text: 'Forma pgto', padrao: true, sortable: true },
    { value: 'gateway', text: 'Gateway', padrao: false, sortable: true },
    { value: 'vencimento', text: 'Vencimento', padrao: true, sortable: true },
    { value: 'paid_at', text: 'Pago em', padrao: true, sortable: true },
    { value: 'dias_atraso', text: 'Atraso', padrao: true, sortable: true },
    { value: 'nfse_numero', text: 'Nota fiscal', padrao: false, sortable: true },
    { value: 'alteracoes_vencimento', text: 'Alt. venc.', padrao: false, sortable: true },
    { value: 'created_at', text: 'Emissão', padrao: true, sortable: true },
    { value: 'acoes', text: '', padrao: true, sortable: false },
];

export const COLUNAS_TAXAS = [
    { value: 'id', text: 'ID', padrao: false, sortable: true },
    { value: 'paid_at', text: 'Pago em', padrao: true, sortable: true },
    { value: 'empresa', text: 'Empresa', padrao: true, sortable: true, fixa: true },
    { value: 'empresa_ativa', text: 'Emp. ativa', padrao: true, sortable: true },
    { value: 'metodo', text: 'Método', padrao: true, sortable: true },
    { value: 'conta', text: 'Conta', padrao: false, sortable: true },
    { value: 'valor_total', text: 'Transação', padrao: true, sortable: true },
    { value: 'valor_taxa', text: 'Taxa', padrao: true, sortable: true },
    { value: 'percentual', text: '% efetivo', padrao: true, sortable: true },
    { value: 'taxa_configurada', text: 'Taxa config.', padrao: true, sortable: false },
    { value: 'pedido_id', text: 'Pedido', padrao: false, sortable: true },
    { value: 'mp_payment_id', text: 'MP Payment', padrao: false, sortable: true },
    { value: 'external_reference', text: 'External ref', padrao: false, sortable: false },
    { value: 'created_at', text: 'Registrado em', padrao: false, sortable: true },
];

/**
 * No modo agrupado a linha deixa de ser uma transação, então o grid troca de colunas por inteiro —
 * configurar colunas de transação ali não faria sentido.
 */
export const COLUNAS_TAXAS_AGRUPADAS = [
    { text: 'Grupo', value: 'rotulo', sortable: true },
    { text: 'Transações', value: 'qtd_transacoes', sortable: true },
    { text: 'Processado', value: 'total_processado', sortable: true },
    { text: 'Taxa arrecadada', value: 'total_taxa', sortable: true },
    { text: '% efetivo', value: 'percentual_efetivo', sortable: true },
];

export const catalogoColunasCobrancas = criarCatalogoColunas(COLUNAS_COBRANCAS);
export const catalogoColunasTaxas = criarCatalogoColunas(COLUNAS_TAXAS);
